import { Component } from '@angular/core';
import { ItemsListContentGridViewComponent } from '../content-grid-view/content-grid-view.component';

@Component({
    selector: 'fi-items-list-content-grid-view-with-children',
    templateUrl: './content-grid-view-with-children.component.html',
    styleUrls: ['./content-grid-view-with-children.component.scss'],
    standalone: false,
})
export class ItemsListContentGridViewWithChildrenComponent extends ItemsListContentGridViewComponent {}
